module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-5.3e79062f.svg";